<template>
  <footer
    class="footer mt-12 py-6 px-6 md:px-12 lg:px-20 bg-black shadow-2xl border-t border-primary-700/30">
    <div
      class="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <div class="flex flex-col items-center md:items-start">
        <img
          src="/images/FDC_Logo_slogan_blanc.svg"
          alt="Logo FDC"
          class="mb-2 w-80 h-32 md:w-auto md:h-20" />
        <div
          class="mt-2 text-lg font-semibold text-white tracking-wide text-center md:text-left">
          La Finance avec <span class="text-primary-400">un Point de vue</span>
        </div>
      </div>
      <div class="flex flex-col items-center md:items-start">
        <ul
          class="flex flex-col md:flex-row gap-2 md:gap-3 list-none text-white text-sm">
          <li>
            <router-link
              to="/informationsReglementaires"
              class="footer-menu-btn">
              <span class="footer-menu-icon bg-primary-700"
                ><i class="pi pi-file"></i
              ></span>
              <span class="ml-2 md:ml-0"
                >Informations r&egrave;glementaires</span
              >
            </router-link>
          </li>
          <li>
            <router-link to="/avertissement" class="footer-menu-btn">
              <span class="footer-menu-icon bg-primary-700"
                ><i class="pi pi-info-circle"></i
              ></span>
              <span class="ml-2 md:ml-0">Avertissement</span>
            </router-link>
          </li>
          <li>
            <router-link to="/mentionsLegales" class="footer-menu-btn">
              <span class="footer-menu-icon bg-primary-700"
                ><i class="pi pi-verified"></i
              ></span>
              <span class="ml-2 md:ml-0">Mentions l&eacute;gales</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="flex flex-col items-center md:items-start">
        <ul class="list-none text-white text-sm space-y-2">
          <li>
            <a
              class="text-white/90 hover:text-primary-400 transition-colors duration-150 font-medium flex items-center"
              href="https://www.bing.com/maps?osid=08a394a5-3c59-4b61-9cd1-05228868f3cb&cp=48.868029~2.330294&lvl=16.66&pi=0&imgid=7cc4cc4a-78c2-4809-9410-11466663f19a&v=2&sV=2&form=S00027"
              target="_blank">
              <i class="pi pi-map-marker mr-2"></i>30, avenue de l'Opéra, 75002
              Paris
            </a>
          </li>
          <li>
            <a
              class="text-white/90 hover:text-primary-400 transition-colors duration-150 font-medium flex items-center"
              href="tel:+33153933830">
              <i class="pi pi-phone mr-2"></i>+33 1 53 93 38 30
            </a>
          </li>
          <li>
            <span
              class="text-white/90 hover:text-primary-400 transition-colors duration-150 font-medium flex items-center">
              <i class="pi pi-print mr-2"></i>+33 1 53 53 99 91
            </span>
          </li>
          <li>
            <a
              class="text-white/90 hover:text-primary-400 transition-colors duration-150 font-medium flex items-center"
              href="mailto:investisseurs@financieredelacite.com">
              <i class="pi pi-envelope mr-2"></i
              >investisseurs@financieredelacite.com
            </a>
          </li>
        </ul>
      </div>
      <div class="flex flex-row items-center justify-center gap-4 mt-4 md:mt-0">
        <a
          class="bg-white/10 hover:bg-primary-400 text-white hover:text-white rounded-full p-3 transition-all duration-200 shadow-lg flex items-center justify-center"
          style="font-size: 1.5rem; width: 48px; height: 48px"
          href="https://www.linkedin.com/company/financiere-de-la-cite-fdc"
          target="_blank"
          title="LinkedIn">
          <i class="pi pi-linkedin"></i>
        </a>
        <a
          class="bg-white/10 hover:bg-primary-400 text-white hover:text-white rounded-full p-3 transition-all duration-200 shadow-lg flex items-center justify-center"
          style="font-size: 1.5rem; width: 48px; height: 48px"
          href="https://x.com/FinCite"
          target="_blank"
          title="X">
          <i class="pi pi-twitter"></i>
        </a>
        <a
          class="bg-white/10 hover:bg-primary-400 text-white hover:text-white rounded-full p-3 transition-all duration-200 shadow-lg flex items-center justify-center"
          style="font-size: 1.5rem; width: 48px; height: 48px"
          href="https://www.youtube.com/channel/UCXJ3yajEEmo19x4rHSHJB9g"
          target="_blank"
          title="Youtube">
          <i class="pi pi-youtube"></i>
        </a>
      </div>
    </div>
    <div class="mt-8 text-center text-xs text-surface-400">
      &copy; {{ new Date().getFullYear() }} Financière de la Cité. Tous droits
      réservés.
    </div>
  </footer>
</template>

<style scoped>
  .footer {
    width: 100%;
    box-shadow: 0 -2px 24px 0 rgba(0, 0, 0, 0.12);
  }
  .footer-menu-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(30, 41, 59, 0.1); /* bleu foncé très léger */
    border-radius: 1.5rem;
    padding: 0.45rem 1.1rem;
    color: #e5e7eb;
    font-weight: 500;
    transition:
      background 0.18s,
      color 0.18s,
      box-shadow 0.18s;
    box-shadow: none;
    text-decoration: none;
    position: relative;
  }
  .footer-menu-btn:hover {
    background: rgba(30, 41, 59, 0.18);
    color: #f3f4f6;
    box-shadow: none;
    transform: none;
  }
  .footer-menu-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    background: rgba(30, 41, 59, 0.18);
    color: #cbd5e1;
    font-size: 1.1rem;
    box-shadow: none;
    transition:
      background 0.18s,
      color 0.18s;
  }
  .footer-menu-btn:hover .footer-menu-icon {
    background: rgba(30, 41, 59, 0.28);
    color: #fff;
  }
  @media (max-width: 768px) {
    .footer {
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .footer-menu-btn {
      /* flex-direction: row par défaut, on ne force plus column */
      gap: 0.2rem;
      padding: 0.5rem 0.7rem;
      font-size: 0.95rem;
    }
    .footer-menu-icon {
      margin-bottom: 0.2rem;
    }
    .footer-menu-btn span.ml-2 {
      margin-left: 0 !important;
    }
  }
</style>
